import type React from 'react'
import type { JSX } from 'react'
import type { ITimeLine } from 'blocks/TimeLine'
import type { FIXED_INDENTS, LAYOUT } from 'vars/index'

import { useState } from 'react'
import { TimeLine } from 'blocks/TimeLine'
import { useClientWidth } from 'utils/hooks'
import { ChannelProgramList } from './components'
import { ProgramListSC } from './ProgramList.styled'

export interface IProgramList {
  children: React.ReactNode | React.ReactNode[]
  now: ITimeLine['now']
  startTime: ITimeLine['startTime']
  scaleDivision: ITimeLine['scaleDivision']
  onUpdateTime?: ITimeLine['onUpdateTime']
  onUpdateStartTime?: ITimeLine['onUpdateStartTime']
  formatTime: ITimeLine['formatTime']
  selectedCategoryTabId: number | null
  channelCardWidth?: number
  channelCardHeight?: number
  tableGap?: number
  onLoadMore?: () => void
  percentToTrigger?: number
  coveredDays: Array<{
    stamp: number
    formattedString: string
  }>
  paddings?: Array<FIXED_INDENTS | LAYOUT>
  channelPrograms: any[]
}

export const ProgramList = ({
  now,
  formatTime,
  startTime,
  scaleDivision,
  onUpdateTime,
  onUpdateStartTime,
  children,
  channelCardWidth = 165,
  tableGap = 2,
  channelCardHeight = 84,
  onLoadMore,
  percentToTrigger = 50,
  coveredDays,
  selectedCategoryTabId,
  paddings,
}: IProgramList): JSX.Element => {
  const [timeBlockWidth, setTimeBlockWidth] = useState<number | undefined>()
  const [step, setStep] = useState<number | undefined>()
  const [showProgressLine, updateShowProgressLine] = useState<boolean>(false)
  const [sections, setSections] = useState(1)

  const minuteWithStart = new Date(now - startTime).getMinutes()
  const clientWidth = useClientWidth()
  const adaptiveCardWidth =
    clientWidth > 1239 ? channelCardWidth : channelCardHeight
  const progressPosition =
    adaptiveCardWidth + tableGap + step! * minuteWithStart
  const startTimeLine = startTime
  const stopTimeLine = startTimeLine + scaleDivision * sections

  return (
    <ProgramListSC
      channelCardWidth={channelCardWidth}
      tableGap={tableGap}
      progressPosition={progressPosition}
      timeBlockWidth={timeBlockWidth}
      channelCardHeight={channelCardHeight}
      paddings={paddings}
    >
      <TimeLine
        now={now}
        startTime={startTime}
        scaleDivision={scaleDivision}
        onUpdateTime={onUpdateTime}
        onUpdateStartTime={onUpdateStartTime}
        setTimeBlockWidth={setTimeBlockWidth}
        updateStep={setStep}
        updateShowProgressLine={updateShowProgressLine}
        setSections={setSections}
        coveredDays={coveredDays}
        formatTime={formatTime}
      />
      <ChannelProgramList
        showProgressLine={showProgressLine}
        step={step}
        startTimeLine={startTimeLine}
        stopTimeLine={stopTimeLine}
        selectedCategoryTabId={selectedCategoryTabId}
        onLoadMore={onLoadMore}
        percentToTrigger={percentToTrigger}
        tableGap={tableGap}
      >
        {children}
      </ChannelProgramList>
    </ProgramListSC>
  )
}
